import { Endpoint } from 'core/api';
import { compile } from 'path-to-regexp';

export function mapParamsToEndpoint<T>({ endpoint, ...rest }: Endpoint<T>, params: any): Endpoint<T> {
  return {
    endpoint: compile(endpoint)(params),
    ...rest,
  };
}
